export default __webpack_public_path__ + "static/media/right_arrow.b89fe79a.svg";